import { apiGet, apiPost, apiPut, apiDelete } from '@/services/api/apiClient';
import {
  CreateCompanyRequest,
  UpdateCompanyRequest,
  CompanyListParams,
  CompanyResponse,
  CompanyListResponse,
} from '@/constants/types';

export const companyService = {
  async getCompanies(params?: CompanyListParams): Promise<CompanyListResponse> {
    const searchParams = new URLSearchParams();
    
    if (params?.search) searchParams.append('search', params.search);
    if (params?.isActive !== undefined) searchParams.append('isActive', params.isActive.toString());
    if (params?.page) searchParams.append('page', params.page.toString());
    if (params?.limit) searchParams.append('limit', params.limit.toString());
    if (params?.sort) searchParams.append('sort', params.sort);

    return await apiGet<CompanyListResponse>(`/company?${searchParams.toString()}`);
  },

  async getCompany(id: string): Promise<CompanyResponse> {
    return await apiGet<CompanyResponse>(`/company/${id}`);
  },

  async createCompany(data: CreateCompanyRequest): Promise<CompanyResponse> {
    return await apiPost<CompanyResponse>('/company', data);
  },

  async updateCompany(id: string, data: UpdateCompanyRequest): Promise<CompanyResponse> {
    return await apiPut<CompanyResponse>(`/company/${id}`, data);
  },

  async deleteCompany(id: string): Promise<{ success: boolean; message: string }> {
    return await apiDelete<{ success: boolean; message: string }>(`/company/${id}`);
  },
};